import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import {
    policyDetailRequest, assignPolicyRequest, assignPolicyRequestStatus,
    policyMarkCompleteRequest, policyMarkCompleteRequestStatus
} from '../../../redux/policy/policy.action'
import moment from "moment";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { employeeListRequest } from '../../../redux/employee/employee.action'
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const PolicyDetail = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { state } = useLocation()
    const { policyDetailSuccess, policyDetailError,
        assignPolicySuccess, assignPolicyError, assignPolicyReqStatus,
        policyMarkCompleteSuccess, policyMarkCompleteError, policyMarkCompleteReqStatus } = useSelector(state => state.policy)
    const { employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    const [selectedEmployee, setSelectedEmployee] = useState(null)
    const [assignEmployeeModal, setShowAssignEmployeeModal] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')
    const [startDate, setStartDate] = useState(new Date())

    useEffect(() => {
        fetchPolicytDetail()
    }, [])

    const fetchPolicytDetail = () => {
        setLoading(true)
        const data = {
            id: state.policyId,
            params: {
                businessId: state.businessId,
                locationId: state.locationId
            }
        }
        dispatch(policyDetailRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(policyDetailSuccess)) {
            setLoading(false)
        } else if (!isEmpty(policyDetailError)) {
            setLoading(false)
        }
    }, [policyDetailSuccess, policyDetailError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    useEffect(() => {
        if (assignPolicyReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(assignPolicySuccess.data.message)
            fetchPolicytDetail()
        } else if (assignPolicyReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(assignPolicyError.message)
        }
        if (assignPolicyReqStatus?.length) {
            dispatch(assignPolicyRequestStatus(''))
        }
    }, [assignPolicySuccess, assignPolicyError, assignPolicyReqStatus])

    useEffect(() => {
        if (policyMarkCompleteReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(policyMarkCompleteSuccess.data.message)
            fetchPolicytDetail()
        } else if (policyMarkCompleteReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(policyMarkCompleteError.message)
        }
        if (policyMarkCompleteReqStatus?.length) {
            dispatch(policyMarkCompleteRequestStatus(''))
        }
    }, [policyMarkCompleteSuccess, policyMarkCompleteError, policyMarkCompleteReqStatus])

    const handleAssignClick = (isAssignToMe = false) => {
        if (!isAssignToMe && isEmpty(selectedEmployee)) {
            displayErrorToast('Employee not selected')
        } else if (isEmpty(policyDetailSuccess)) {
            displayErrorToast('Policy details not found. Please try again')
        } else {
            let userId
            let userType
            if (isAssignToMe) {
                if (isLoggedInUserBusiness(user)) {
                    userId = user.data.userDetails.userId
                    userType = user.data.userDetails.userType
                } else {
                    userId = user.data.userDetails.employeeId
                    userType = user.data.userDetails.userType
                }
            } else {
                userId = selectedEmployee.employeeId
                userType = selectedEmployee.userType
            }
            const assignedEmp = policyDetailSuccess.data.enrolleeList.find(item => parseFloat(item.id) === userId && item.userType === userType)
            if (!isEmpty(assignedEmp)) {
                displayErrorToast('Policy already assigned to employee')
            } else {
                setLoading(true)
                const data = {
                    policyId: state.policyId,
                    employeeId: userId,
                    userType: userType,
                    dueDate: startDate
                }
                dispatch(assignPolicyRequest(data))
            }
        }
    }

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(state.businessId)) {
                data.businessId = state.businessId
            }
            if (!isEmpty(state.locationId)) {
                data.locationId = state.locationId
            }
        } else if (isLoggedInUserEmployee(user)) {
            if (!isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
                data.businessId = employeeSelectedBusiness
                data.locationId = employeeSelectedLocation
            }
        }
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(employeeListRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(selectedEmployee)) {
            handleAssignClick()
            setShowAssignEmployeeModal(false)
        }
    }, [selectedEmployee])

    const showMarkCompleteBtn = (item) => {
        if (!isEmpty(state) && state.isAssignedPolicies === true) {
            let id = isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId
            let userType = user.data.userDetails.userType
            let assignObj = item.enrolleeList.find(enList => parseFloat(enList.id) === parseFloat(id) && enList.userType === userType)
            if (!isEmpty(assignObj) && assignObj.status !== APP_CONSTANTS.POLICY_STATUS.COMPLETE) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }

    }

    const handleMarkComplete = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try again')
        } else {
            setLoading(true)
            let id = isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId
            let userType = user.data.userDetails.userType
            const data = {
                policyId: state.policyId,
                employeeId: id,
                userType: userType
            }
            dispatch(policyMarkCompleteRequest(data))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Policy Details' />
                {!isEmpty(policyDetailSuccess) && !isEmpty(policyDetailSuccess.data) && <CommonFormBorder>
                    <div className="pd-img-parent-container">
                        <div className="pd-img-container">
                            <img src={require('../../../assets/logo_togethra.png')} className="img" />
                        </div>
                    </div>
                    <div className="pd-name-label">{policyDetailSuccess.data.name}</div>
                    <div className="pd-description-label">{policyDetailSuccess.data.description}</div>
                    <FormFieldLabel className='up-bold-label' label='Policy Link' />
                    <div className="pd-link-label" onClick={() => { window.open(policyDetailSuccess.data.onlineLink, "_blank") }}>{policyDetailSuccess.data.onlineLink}</div>
                    <FormFieldLabel className='up-bold-label' label='Enrollees' />
                    {!isNull(policyDetailSuccess.data.enrolleeListDetail) && <div className="table-scroll-container">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col" className="text-center">Due Date</th>
                                    <th scope="col" className="text-center">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {policyDetailSuccess.data.enrolleeListDetail.map(element => (
                                    <tr className="loc-table-row-container">
                                        <td>{element.firstName} {element.lastName}</td>
                                        <td className="text-center">{moment.utc(element.policyDueDate).local().format('DD MMM YYYY')}</td>
                                        <td className="text-center">{removeSpecialCharAndChangeToPascal(element.policyStatus)}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>}
                    {isEmpty(policyDetailSuccess.data.enrolleeListDetail) && <div className="content-error">No enrollee found</div>}
                    <div className="pd-ae-container">
                        <div className="pd-ae-btn" onClick={() => setShowAssignEmployeeModal(true)}>Assign Employee</div>
                    </div>
                    {showMarkCompleteBtn(policyDetailSuccess.data) && <ButtonRow>
                        <CommonButton label='Mark Complete' onClick={() => { handleMarkComplete() }} />
                    </ButtonRow>}
                </CommonFormBorder>}
                {!isEmpty(policyDetailError) && <div className="content-error">{policyDetailError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowAssignEmployeeModal(false) }}
                show={assignEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Select employee
                </Modal.Header>
                <Modal.Body>
                    <div className="pd-date-parent-container">
                        <FormFieldLabel label='Select Due Date' />
                        <DatePicker
                            className="as-date-container"
                            selected={startDate}
                            minDate={new Date()}
                            onChange={(date) => {
                                setStartDate(date)
                            }}
                            dateFormat="MMMM d, yyyy"
                        />
                    </div>
                    <div className="ol-search-parent-container">
                        <div className="ol-search-row-parent-container">
                            <div className="ol-search-input-container">
                                <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Employee" />
                            </div>
                            <div className="ol-search-icon-container" onClick={() => { fetchEmployeeList() }}>
                                <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                            </div>
                        </div>
                    </div>
                    {!isEmpty(employeeListSuccess) && <div className="ae-emp-list-container">
                        {!isEmpty(employeeListSuccess.data) && employeeListSuccess.data.map(e => (<div className="ae-emp-list-item-container">
                            <div className="ae-emp-list-item-content-container">
                                <div className="ae-emp-name-label">{e.firstName} {e.lastName}</div>
                                <div className="ae-emp-code-label">{e.employeeCode}</div>
                                <div className="ae-emp-name-label">{e.role}</div>
                            </div>
                            <div className="ae-row-btn-container" onClick={() => {
                                setSelectedEmployee(e)
                            }}>Assign</div>
                        </div>))}
                    </div>}
                    {!isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                    <div className="td-or-label">OR</div>
                    <div className="td-or-btn-container">
                        <CommonButton label='Assign to me' onClick={() => { handleAssignClick(true) }} />
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PolicyDetail